import { ThunkAction } from 'redux-thunk'

import { State } from './index'

import config from 'admin/config/main'
import { reduxDependenciesType } from 'admin/redux/create'
import {
  InvoiceSpecificationSummary,
  InvoicesListType,
  InvoiceStatus,
} from 'admin/types'
import { InvoicesParamsType } from 'admin/types/api'
import
 createApiReducer, {
  requestDataFor,
  receiveDataFor,
  handleErrorFor,
} from 'redux/utils/createApiDuck'
import { APIState } from 'types'

const moduleName = `${config.appName  }/invoices`

export default createApiReducer(moduleName)

/**
 *
 * @param orgAccountId
 * @param params The date filter sets the time in from date to 00.00.00.00
 * and the time in to date to 23.59.59.999
 */
export function fetchInvoicesWithParams(
  orgAccountId: string,
  params?: InvoicesParamsType,
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return new Promise((resolve, reject) => {
      if (
        params &&
        params.filters &&
        params.filters.status === InvoiceStatus.UNPAID
      ) {
        return api
          .getInvoices(orgAccountId, {
            ...params,
            filters: {
              ...params.filters,
              status: null,
              'exclude-status': InvoiceStatus.PAID,
            },
          })
          .then(data => resolve(data))
          .catch(error => reject(error))
      } 
        return api
          .getInvoices(orgAccountId, params)
          .then(data => resolve(data))
          .catch(error => reject(error))
      
    })
      .then((data: InvoiceSpecificationSummary[]) => {
        const totalNumberFiltered = data ? data.length : 0
        const enrichedData: InvoicesListType = {
          invoices: data,
          totalNumberFiltered,
        }
        dispatch(receiveDataFor(moduleName)(enrichedData))
      })
      .catch(error => dispatch(handleErrorFor(moduleName)(error)))
  }
}

export interface InvoicesState extends APIState {
  data: InvoicesListType
}
